import React from 'react';
import { Popover } from 'baseui/popover';
import { IDummyProps } from './typesStateless';
import { overrides as customOverrides } from './overrides';
import { mergeOverrides } from 'baseui';

export const StatelessPopover = (props: IDummyProps, ref: any) => {
	const { showArrow = true, anchorProps, overrides, triggerType, ...rest } = props;

	return (
		<Popover
			ref={ref}
			showArrow={showArrow}
			triggerType={triggerType}
			overrides={overrides ? mergeOverrides(customOverrides(props), overrides) : customOverrides(props)}
			{...rest}
		>
			{anchorProps && (
				<div style={{ display: 'inline-flex' }} {...anchorProps}>
					{props.children}
				</div>
			)}
			{!anchorProps && props.children}
		</Popover>
	);
};
